import React, { Component } from 'react'
import { Col, Row, Button } from 'reactstrap'
import Card from '../../../comum/components/Card'
import { inject, observer } from 'mobx-react'
import SelectFiltro from '../../../comum/components/SelectFiltro'
import FormInputSimples from '../../../comum/components/FormInputSimples'
import { FecharFiltro, Filtro, IconeCarregar } from '../../../comum/components/Icones'
import FormSelectSimples from '../../../comum/components/FormSelectSimples'
import CheckboxField from '../../../comum/components/CheckboxField'

@inject("store")
@observer
export default class FiltrosDirecionamento extends Component {

    constructor(props) {
        super(props)

        this.controller = this.props.controller

        this.state = {
            maisFiltros: false
        }

        this.filtros = this.filtros.bind(this)
        this.showFiltros = this.showFiltros.bind(this)
    }

    showFiltros() {
        this.setState({
            maisFiltros: !this.state.maisFiltros
        })
    }

    filtros() {
        return (
            <Row className="pb-0">
                <FormSelectSimples titulo="Operação"
                    xs={this.controller.loadingOperacoes ? 11 : 12}
                    sm={this.controller.loadingOperacoes ? 11 : 12}
                    md={4} lg={3} xl={2}
                    itens={this.controller.listaOperacoes}
                    dado={this.controller.operacao}
                    bloqueado={this.controller.listaOperacoes.length === 0}
                    onChange={this.controller.setOperacao}
                />
                {this.controller.loadingOperacoes ? <IconeCarregar tamanho="2x" /> : null}
                <CheckboxField  xs={12} sm={12} md={4} lg={3} xl={2}
                    text={this.controller.navioAssociado ? "Sim" : "Não"}
                    titulo="Sem navio associado?"
                    ativo={this.controller.navioAssociado}
                    onClick={this.controller.setFiltroNavioAssociado}
                />
                {this.state.maisFiltros &&
                    <React.Fragment>
                        <FormSelectSimples xs={12} sm={12} md={4} lg={3} xl={2}
                            titulo="Status"
                            itens={this.controller.listaStatus}
                            dado={this.controller.status}
                            onChange={this.controller.setStatus}
                        />
                        <FormInputSimples xs={12} sm={12} md={4} lg={3} xl={2}
                            titulo="CE House"
                            value={this.controller.ce}
                            limiteMaximo={15}
                            onEnter={() => this.controller.listarDirecionamentos()}
                            onChange={(event) => this.controller.setCe(event.target.value)}
                        />
                        <FormInputSimples xs={12} sm={12} md={4} lg={3} xl={2}
                            titulo="Container"
                            value={this.controller.container}
                            onEnter={() => this.controller.listarDirecionamentos()}
                            onChange={(event) => this.controller.setContainer(event.target.value)}
                        />
                        <FormInputSimples xs={12} sm={12} md={4} lg={3} xl={2}
                            titulo="CNPJ"
                            value={this.controller.cnpj}
                            onEnter={() => this.controller.listarDirecionamentos()}
                            onChange={(event) => this.controller.setCnpj(event.target.value)}
                        />
                        <FormInputSimples xs={12} sm={12} md={4} lg={3} xl={2}
                            titulo="Cliente"
                            value={this.controller.cliente}
                            onEnter={() => this.controller.listarDirecionamentos()}
                            onChange={(event) => this.controller.setCliente(event.target.value)}
                        />
                    </React.Fragment>
                }
                <Col className="col-botoes" xl={3} lg={4} md={6} sm={12} xs={12}>
                <Button className={`btn-filtros ${this.state.maisFiltros && 'ativo'}`} onClick={ this.showFiltros } outline >
                    { this.state.maisFiltros ?
                        <div><FecharFiltro color="#93A0AD" className="mr-2" width="15" height="15"/> Menos filtros</div>
                        :
                        <div><Filtro color="#93A0AD" className="mr-2" width="15" height="15"/> Mais filtros</div>
                    }
                </Button>
                    <Button className="btn-com-bordas-primary btn-filtrar" onClick={() => this.controller.listarDirecionamentos()}>Filtrar</Button>
                </Col>
            </Row>
        )
    }

    render() {
        return (
            <div className="filtro-card filtros-cabotagem">
            <Card className={`area-form pb-0`}>
                {this.filtros()}
            </Card>
        </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/modules/direcionamento/tecon/components/FiltrosDirecionamento.js